import { storeContext } from '../app';
import { useContext } from "react";

export const useStoreContext = () => useContext(storeContext);
export const observer = (C) => {
  return typeof window._observer === 'function' ? window._observer(C) : null;
};
